// event - string, params - object or null
export function sendAnalyticsEventToNative(event, params = null) {
  if (window.AndroidBridge && window.AndroidBridge.trackEventWebView) {
    window.AndroidBridge.trackEventWebView(event, params ? JSON.stringify(params) : params);
  }

  // for ios
  if (window.trackWebEvent) {
    window.trackWebEvent(event, params)
  }
}